import { ObservableArray, View } from "binder"
import { PaymentGatewaySelectorViewModel } from "./paymentGatewaySelector-viewModel"
import { IGateway, PaymentInfo } from "./gateways/IGateway";

export class PaymentGatewaySelectorView extends View<PaymentGatewaySelectorViewModel> {
    GetViewUniqueId(): string {
        return "V-D73933DE-7B9E-490D-A4E9-4995A53A0104"
    }
    loadHtml(): string {
        let element = require('./paymentGatewaySelector.html').default;
        let style = require('./paymentGatewaySelector.less');
        return element;
    }
    constructor() {
        super();
    }

    public set gateways(v: ObservableArray<IGateway>) { this._gateways = v; } public get gateways(): ObservableArray<IGateway> { return this._gateways; } private _gateways: ObservableArray<IGateway>;
    public set paymentInfo(v: PaymentInfo) { this._paymentInfo = v; } public get paymentInfo(): PaymentInfo { return this._paymentInfo; } private _paymentInfo: PaymentInfo;
    public set selectedGateway(v: IGateway) { this._selectedGateway = v; } public get selectedGateway(): IGateway { return this._selectedGateway;} private _selectedGateway: IGateway;
}
